import { render, staticRenderFns } from "./keypartsDialog.vue?vue&type=template&id=6cfb3070&scoped=true"
import script from "./keypartsDialog.vue?vue&type=script&lang=js"
export * from "./keypartsDialog.vue?vue&type=script&lang=js"
import style0 from "./keypartsDialog.vue?vue&type=style&index=0&id=6cfb3070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb3070",
  null
  
)

export default component.exports